var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_635_8491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80467 14.9645H11.578C12.1989 14.9645 12.7069 14.4565 12.7069 13.8357V4.80455C12.7069 4.18366 12.1989 3.67566 11.578 3.67566H4.80467C4.18378 3.67566 3.67578 4.18366 3.67578 4.80455V13.8357C3.67578 14.4565 4.18378 14.9645 4.80467 14.9645ZM4.80467 23.9957H11.578C12.1989 23.9957 12.7069 23.4877 12.7069 22.8668V18.3512C12.7069 17.7303 12.1989 17.2223 11.578 17.2223H4.80467C4.18378 17.2223 3.67578 17.7303 3.67578 18.3512V22.8668C3.67578 23.4877 4.18378 23.9957 4.80467 23.9957ZM16.0936 23.9957H22.8669C23.4878 23.9957 23.9958 23.4877 23.9958 22.8668V13.8357C23.9958 13.2148 23.4878 12.7068 22.8669 12.7068H16.0936C15.4727 12.7068 14.9647 13.2148 14.9647 13.8357V22.8668C14.9647 23.4877 15.4727 23.9957 16.0936 23.9957ZM14.9647 4.80455V9.3201C14.9647 9.94099 15.4727 10.449 16.0936 10.449H22.8669C23.4878 10.449 23.9958 9.94099 23.9958 9.3201V4.80455C23.9958 4.18366 23.4878 3.67566 22.8669 3.67566H16.0936C15.4727 3.67566 14.9647 4.18366 14.9647 4.80455Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_635_8491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.0933,
    height: 27.0933,
    fill: "white",
    transform: "translate(0.289062 0.28894)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.753320cca3fc62312ca1e4e502b43d02.svg";
export { ForwardRef as ReactComponent };